module.exports = __webpack_public_path__ + "img/third.d7573480.svg";